import * as React from 'react'

function SvgVideoOff(props, svgRef) {
  return (
    <svg viewBox="0 0 32 32" fill="#204566" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.3 8.2A1.3 1.3 0 003 9.5v13a1.3 1.3 0 001.3 1.3h14.3a1.3 1.3 0 001.3-1.3v-.762L6.362 8.2H4.3zM1.542 6.742A3.9 3.9 0 014.3 5.6h2.6a1.3 1.3 0 01.92.38l14.3 14.3a1.3 1.3 0 01.38.92v1.3a3.9 3.9 0 01-3.9 3.9H4.3a3.9 3.9 0 01-3.9-3.9v-13a3.9 3.9 0 011.142-2.758zM18.6 8.2h-4.342a1.3 1.3 0 010-2.6H18.6a3.9 3.9 0 013.9 3.9v3.803l.136.136 6.902-4.992A1.3 1.3 0 0131.6 9.5v13a1.3 1.3 0 11-2.6 0V12.045l-5.738 4.15a1.3 1.3 0 01-1.681-.134l-1.3-1.3a1.3 1.3 0 01-.381-.92V9.5a1.3 1.3 0 00-1.3-1.3z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.78.78a1.3 1.3 0 011.84 0l28.6 28.6a1.3 1.3 0 01-1.84 1.84L.78 2.62a1.3 1.3 0 010-1.84z"
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgVideoOff)
export default ForwardRef
